module.exports = __webpack_public_path__ + "static/media/uip.e8221964.webp";